// extracted by mini-css-extract-plugin
module.exports = {"roadmap":"ProjectInfoPage_roadmap__1mQpn","companyInfo":"ProjectInfoPage_companyInfo__23SvO"};